import { AIOrderChat } from "../../../components/ai-order-chat/AIOrderChat";
import type { PublicMenuController } from "../usePublicMenuController";
import { CartPanel } from "./CartPanel";
import { ProductCustomizer } from "./ProductCustomizer";

/** Mount inside PublicMenuThemeProvider. All layouts share the same ordering UI. */
export function PublicMenuOverlays({ controller }: { controller: PublicMenuController }) {
  const {
    tenant, aiStatus, branchId, itemCount, lines, products, applyAiCartAction,
    openProduct, quickAddProduct, setCartOpen, editingLine, selectedProduct,
    closeCustomizer, cartOpen, selectBranch, editLine,
  } = controller;
  if (!tenant) return null;
  return (
    <>
      {aiStatus.data?.available ? (
        <AIOrderChat
          assistantAvailable={aiStatus.data.available === true}
          branchId={branchId}
          cartItemCount={itemCount}
          cartLines={lines}
          products={products}
          tenant={tenant}
          onApplyCartAction={applyAiCartAction}
          onOpenProduct={openProduct}
          onQuickAddProduct={quickAddProduct}
          renderInlineProductConfigurator={(product, onAdded, onCancel) => (
            <ProductCustomizer
              branchId={branchId} editLine={null} mode="inline" open
              product={product} products={products} onAdded={onAdded} onClose={onCancel}
            />
          )}
          onOpenCart={() => setCartOpen(true)}
        />
      ) : null}
      <ProductCustomizer
        branchId={branchId} editLine={editingLine} open={Boolean(selectedProduct)}
        product={selectedProduct} products={products} onClose={closeCustomizer}
      />
      <CartPanel
        branchId={branchId} open={cartOpen} products={products}
        onBranch={selectBranch} onClose={() => setCartOpen(false)} onEdit={editLine}
      />
    </>
  );
}
